'use client'

import { useModals } from '@/lib/hooks'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { SelectPaymentCardType } from '@/components/forms/select-payment-card-type'

interface SelectPaymentCardTypeModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const SelectPaymentCardTypeModal = ({
  open,
}: SelectPaymentCardTypeModalProps) => {
  const { closeModal, closeAll } = useModals()

  return (
    <Dialog open={open}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('SELECT_PAYMENT_CARD_TYPE')}
        size="lg"
        className="min-h-[410px]"
      >
        <DialogHeader>
          <DialogTitle>Payment Card</DialogTitle>
          <DialogDescription>
            Select the customer&apos;s card type
          </DialogDescription>
        </DialogHeader>

        {open && <SelectPaymentCardType onClose={() => closeAll()} />}
      </DialogContent>
    </Dialog>
  )
}
